import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const DotsHorizontal: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M2 2H22V22H2V2Z'
        stroke={fill}
        strokeWidth='2'
      />
      <path
        d='M12.5001 11.5H11.4998V12.5004H12.5001V11.5Z'
        stroke={fill}
        strokeWidth='2'
      />
      <path
        d='M17.5001 11.5H16.4998V12.5004H17.5001V11.5Z'
        stroke={fill}
        strokeWidth='2'
      />
      <path
        d='M7.50012 11.5H6.49976V12.5004H7.50012V11.5Z'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default DotsHorizontal
